import { DialogHeader, DialogTitle } from "design-system/dialog";
import { Spinner } from "design-system/spinner";

// Shared spinner screen. Used both as the dialog's lazy-load fallback and while the coordinator runs the org
// lookup, so the modal shows one continuous spinner from open through routing (no flash between the two).
export function LoadingTurnkeyView() {
  return (
    <>
      <DialogHeader>
        <DialogTitle>Set up your wallet</DialogTitle>
      </DialogHeader>
      <div className="flex min-h-32 justify-center py-8">
        <Spinner size="medium" />
      </div>
    </>
  );
}
